var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"marginTop":"100px"}},[_c('ErrorComp',{attrs:{"errorMessage":"The url does not exist"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }